export enum WidgetInternalId {
  BMS_LIST = 'bmsList',
  BMS_DETAIL = 'bmsDetail',
  PCS_LIST = 'pcsList',
  PCS_DETAIL = 'pcsDetail',
  PCS_MODULE_LIST = 'pcsModuleList',
  PCS_CONVERTER_LIST = 'pcsConverterList',
  PCS_PV_LIST = 'pcsPVList',
  PCS_PV_DETAIL = 'pcsPVDetail',
  PCS_PV_MODULE_LIST = 'pcsPVModuleList',
  PCS_PV_CONVERTER_LIST = 'pcsPVConverterList',
  MET_LIST = 'METList',
  MET_DETAIL = 'METDetail',
  MET_MODULE_LIST = 'METModuleList',
  MET_CONVERTER_LIST = 'METConverterList',
  RACK_LIST = 'rackList',
  RACK_DETAIL = 'rackDetail',
  TSC_LIST = 'tscList',
}
